// extracted by mini-css-extract-plugin
export default {"section":"EpisodeList_section__girPx","section--left":"EpisodeList_section--left__OOe06"};